import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import { useMerchant } from '@contexts/admin/MerchantContext'
import ListPageHeader from '@shared/ListPageHeader'
import OrderList from '@shared/orders/OrderList'
import Can from '@shared/permissions/Can'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { orderService } from '@services/admin/orderService'

const AdminOrdersList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    shippingTypes,
  } = useMerchant()
  // useAdminNotification 是 .jsx，JSDoc `@returns {Object}` 讓 TS 把 return 看成空 Object；
  // 這裡 cast 成實際 runtime shape，不是 JSX 元件 cast。
  const { addJob } = useAdminNotification() as { addJob: (...args: any[]) => void }
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.list']}
        actions={
          <>
            <Can requiredPermission="orders:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="orders:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/orders/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <OrderList
        role="admin"
        service={orderService}
        shippingTypes={shippingTypes}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
    </div>
  )
}

export default AdminOrdersList
